import { FormikValues } from 'formik';

export const getChangedValues = async (
  initialValues: any,
  updatedValues: FormikValues
) => {
  if (initialValues.length === 0) {
    return {};
  } else {
    let diff: any = {};
    const newInitialValues = {
      ...initialValues[0][`0`],
      ...initialValues[0][`1`],
      ...initialValues[0][`2`],
    };
    recursiveDiff(newInitialValues, updatedValues, diff);
    Object.keys(diff).forEach((key) => {
      if (diff[key] === '') {
        delete diff[key];
      }
    });
    return diff;
  }
};

export const recursiveDiff = (
  initialValues: any,
  updatedValues: FormikValues,
  node: any
) => {
  for (let prop in initialValues) {
    if (typeof updatedValues[prop] === 'undefined') {
      addNode(prop, '', node);
    } else if (
      JSON.stringify(initialValues[prop]) != JSON.stringify(updatedValues[prop])
    ) {
      if (
        typeof updatedValues[prop] != 'object' ||
        updatedValues[prop] == null
      ) {
        addNode(prop, updatedValues[prop], node);
      } else {
        addNode(prop, {}, node);
        recursiveDiff(initialValues[prop], updatedValues[prop], node[prop]);
      }
    }
  }
};
function addNode(prop: string, value: any, parent: any) {
  parent[prop] = value;
}
